import styles from './ReviewCard.module.scss'
import { FC } from 'react'
import Text from 'shared/ui/Text/Text'
import StarRating from 'shared/ui/StarRating/StarRating'
import Like from 'shared/assets/icons/like.svg'

interface ReviewCardProps {
  amount: string
  avatarColor: string
  likes: number
  name: string
  rating: number
  firstLetter: string
  review: string
  time: string
}

export const ReviewCard: FC<ReviewCardProps> = (props) => {
  const {
    amount,
    avatarColor,
    likes,
    name,
    rating,
    firstLetter,
    time,
    review,
  } = props
  return (
    <div className={styles.ReviewCard}>
      <div className={styles.AvatarWrapper}>
        <div className={styles.avatar} style={{ background: avatarColor }}>
          {firstLetter}
        </div>
      </div>
      <div className={styles.ReviewInfoWrapper}>
        <Text className={styles.UserName} paragraph={name} paragraphSize="m" />
        <Text
          className={styles.UserAmount}
          paragraph={amount}
          paragraphSize="m"
        />
        <div className={styles.UserRatingWrapper}>
          <StarRating rating={rating} starSize="s" />
          <Text
            className={styles.UserRatingTime}
            paragraph={time}
            paragraphSize="s"
          />
        </div>
        <Text
          className={styles.UserReviewText}
          paragraph={review}
          paragraphSize="m"
        />
        <div className={styles.LikesWrapper}>
          <img className={styles.LikeIcon} src={Like} alt="like icon" />
          <Text
            className={styles.LikeText}
            paragraph={likes ? String(likes) : 'Me gusta'}
            paragraphSize="xs"
          />
        </div>
      </div>
    </div>
  )
}
